'use strict';

var toggleOverrideModule = angular.module('feature-toggles-override', ['ng', 'otpp-feature-toggles']);

toggleOverrideModule.provider('featureTogglesOverride', function() {
  var toggleSetterFunction;
  var localStorageKeyPrefix = 'OTPP.FT.';
  var originalToggleValues = {};

  return {
    setToggleSetterFunction: function(setter) {
      toggleSetterFunction = setter;
    },
    $get: function() {
      return {
        setToggle: setToggle,
        setFlagsFromLocalStorage: setFlagsFromLocalStorage,
        resetValues: resetValues
      };

      function setToggle(key, obj) {
        toggleSetterFunction(key, obj);
        localStorage.setItem(localStorageKeyPrefix + key, obj.enabled);
      }

      function setFlagsFromLocalStorage(toggles) {
        originalToggleValues = toggles;
        angular.forEach(toggles, function(obj, key) {
          var localStorageToggleValue = JSON.parse(localStorage.getItem(localStorageKeyPrefix + key));
          if (localStorageToggleValue !== null) {
            setToggle(key, {enabled: localStorageToggleValue});
          } else {
            setToggle(key, obj);
          }
        });
      }

      function resetValues() {
        angular.forEach(originalToggleValues, function(value, key) {
          setToggle(key, value);
        });
      }
    }
  };
});

toggleOverrideModule.controller('featureTogglesOverrideCtrl', function(featureTogglesOverride, featureToggles) {
  this.toggles = featureToggles.getAllFeatures();

  this.toggle = function(key) {
    featureTogglesOverride.setToggle(key, this.toggles[key]);
  };

  this.resetToggles = function() {
    featureTogglesOverride.resetValues();
    this.toggles = featureToggles.getAllFeatures();
  };
});

toggleOverrideModule.directive('featureTogglesOverride', function() {
  return {
    restrict: 'E',
    controller: 'featureTogglesOverrideCtrl as overrideCtrl',
    templateUrl: 'scripts/modules/otpp-feature-toggles/feature-toggles-override.prt.html'
  };
});

toggleOverrideModule.config(function(featureTogglesOverrideProvider, featureTogglesProvider) {
  featureTogglesOverrideProvider.setToggleSetterFunction(featureTogglesProvider.setFeature);
});

toggleOverrideModule.run(function(featureTogglesOverride, featureToggles) {
  featureTogglesOverride.setFlagsFromLocalStorage(featureToggles.getAllFeatures());
});
